<template>
  <!-- Vizualizare carduri -->
  <v-container fluid v-if="viewMode === 'cards'">
    <v-row dense>
      <v-col v-for="user in items" :key="user.id" cols="12" sm="6" md="4" lg="3">
        <v-card variant="flat" class="user-card mx-auto my-4" max-width="400">
          <v-card-title>{{ user.name || $t("users.noName") }}</v-card-title>
          <v-card-text>
            <p><strong>{{ $t("users.fields.email") }}:</strong> {{ user.email }}</p>
            <p><strong>{{ $t("users.fields.role") }}:</strong> {{ user.role || $t("users.roleUndefined") }}</p>
            <p><strong>{{ $t("users.fields.company") }}:</strong> {{ user.company_name || user.company_id || "—" }}</p>
            <p><strong>{{ $t("users.createdAt") }}:</strong> {{ formatDate(user.created_at) }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn icon variant="text" :aria-label="$t('app.actions.edit')" @click="$emit('edit', user)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon variant="text" color="primary" :aria-label="$t('users.fields.role')" @click="$emit('roles', user)">
              <v-icon>mdi-account-key</v-icon>
            </v-btn>
            <v-btn icon variant="text" color="error" :aria-label="$t('app.actions.delete')" @click="$emit('delete', user.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- Vizualizare tabel -->
  <v-container fluid v-else>
    <v-data-table :headers="columns" :items="items" item-key="id" class="my-left-table">
      <template #item="{ item }">
        <tr>
          <td>{{ item.email }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.role || $t("users.roleUndefined") }}</td>
          <td>{{ item.company_name || item.company_id || "—" }}</td>
          <td>{{ formatDate(item.created_at) }}</td>
          <td>{{ formatDate(item.updated_at) }}</td>
          <td>
            <v-btn icon variant="text" size="small" :aria-label="$t('app.actions.edit')" @click="$emit('edit', item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon variant="text" size="small" color="primary" :aria-label="$t('users.fields.role')" @click="$emit('roles', item)">
              <v-icon>mdi-account-key</v-icon>
            </v-btn>
            <v-btn icon variant="text" size="small" color="error" :aria-label="$t('app.actions.delete')" @click="$emit('delete', item.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";

// Users list rendering (cards + table) extracted from users.vue. Presentational
// only: receives the rows, view mode, column defs and a date formatter, and
// emits edit/roles/delete for the parent to act on.
export default defineComponent({
  name: "UserList",
  props: {
    items: { type: Array, default: () => [] },
    viewMode: { type: String, default: "list" },
    columns: { type: Array, default: () => [] },
    formatDate: { type: Function, default: (v) => v },
  },
  emits: ["edit", "roles", "delete"],
});
</script>

<style scoped>
.user-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: var(--app-radius-base);
}
.my-left-table :deep(th),
.my-left-table :deep(td) {
  text-align: left !important;
}
</style>
